import { render, staticRenderFns } from "./PhoneSummary.vue?vue&type=template&id=34350ae9&"
import script from "./PhoneSummary.vue?vue&type=script&lang=js&"
export * from "./PhoneSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports